import {createContext} from "react"
import routes from "views/routeConfig"

const AppContext = createContext({routes})

export default AppContext
